module.exports = __webpack_public_path__ + "img/emoji_71.3d2126b3.png";